module.exports = __webpack_public_path__ + "img/company-honor-MHRA-20231219.fb2b93db.jpg";